import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { text } from "./text";

export function DeleteConfirmationDialog({
  open,
  handleClose,
  handleConfirmClose,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{text.delete}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {text.confirm}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmClose} color="primary">
            {text.yes}
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            {text.no}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
